
import React from "react";
import { DateHelper } from "@rivtn/noseur";
import Btn from "./Btn";
import AccordionItem from "./AccordionItem";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { IWebsiteEvent } from "../../../../../services";

export function eventStatus(ev: IWebsiteEvent): "upcoming" | "live" | "past" {
    if (ev.end_date && DateHelper.isPast(new Date(ev.end_date))) return "past";
    if (ev.start_date && DateHelper.isPast(new Date(ev.start_date))) return "live";
    return "upcoming";
}

export interface EventItemProps {
    index: number;
    open: boolean;
    event: IWebsiteEvent;
    onToggle: () => void;
}

function EventItem({ index, open, event: ev, onToggle }: EventItemProps) {

    const labels = i18nManager.Labels.events;
    const status = eventStatus(ev);

    return (<AccordionItem index={index} open={open} onToggle={onToggle} title={ev.title}
        meta={ev.start_date ? Utils.fineDateShort(new Date(ev.start_date)) : undefined}>
        <div className={styles["event-body"]}>
            <div className={styles["event-info"]}>
                <div className={styles["chips"]}>
                    <span className={styles["chip"]}>{status === "past" ? labels.concluded : labels[status]}</span>
                    {ev.location && (<span className={styles["chip"]}><i className="fa fa-location-dot" /> {ev.location}</span>)}
                    {ev.start_date && (<span className={styles["chip"]}><i className="fa fa-calendar" /> {Utils.fineDate(new Date(ev.start_date))}</span>)}
                </div>
                {ev.details && (<p className={styles["event-details"]}>{ev.details}</p>)}
                {(ev.action_location) && (<Btn size="sm" href={ev.action_location} target="_blank">{ev.action_label || ev.action_location}</Btn>)}
            </div>
            {ev.media_location && (<div className={styles["event-img"]}><img src={ev.media_location} alt={ev.title} loading="lazy" /></div>)}
        </div>
    </AccordionItem>);
}

export default EventItem;
